import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
    },

    {
        path: '/whats-on',
        name: 'whats-on',
        component: () => import(/* webpackChunkName: "whats-on" */ '../views/WhatsOn.vue')
    },

    {
        path: '/exhibitions',
        name: 'exhibition-list',
        meta: 'list',
        props: true,
        component: () => import(/* webpackChunkName: "list" */ '../views/List.vue')
    },

    {
        path: '/events',
        name: 'event-list',
        meta: 'list',
        props: true,
        component: () => import(/* webpackChunkName: "list" */ '../views/List.vue')
    },


    {
        path: '/exhibition/:slug',
        name: 'single-exhibition',
        meta: 'single-post',
        props: true,
        component: () => import(/* webpackChunkName: "single" */ '../views/Post.vue')
    },

    {
        path: '/event/:slug',
        name: 'single-event',
        meta: 'single-post',
        props: true,
        component: () => import(/* webpackChunkName: "single" */ '../views/Post.vue')
    },

    {
        path: '/press/:slug',
        name: 'single-press',
        meta: 'single-press',
        props: true,
        component: () => import(/* webpackChunkName: "single-press" */ '../views/Press.vue')
    },

    {
        path: '/project/:slug',
        name: 'single-project',
        meta: 'single-post',
        props: true,
        component: () => import(/* webpackChunkName: "single" */ '../views/Post.vue')
    },

    {
        path: '/shop',
        name: 'shop-page',
        props: true,
        component: () => import(/* webpackChunkName: "shop" */ '../views/Shop.vue')
    },

    {
        path: '/product-category/:slug',
        name: 'shop-category',
        props: true,
        component: () => import(/* webpackChunkName: "shop" */ '../views/Shop.vue')
    },

    {
        path: '/product/:slug',
        name: 'single-product',
        props: true,
        component: () => import(/* webpackChunkName: "single-product" */ '../views/Product.vue')
    },


    {
        path: '/search',
        name: 'search',
        props: true,
        component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue')
    },

    {
        path: '/:page_slug',
        name: 'page',
        meta: 'page',
        props: true,
        component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
    },

    {
        path: '/:page_slug/:sub_page_slug',
        name: 'sub-page',
        meta: 'page',
        props: true,
        component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
    },

    {
        path: '*',
        name: 'not-found',
        component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue')
    },
]


let base_url = '/';
if (process.env.NODE_ENV === 'production') base_url = '/';

const router = new VueRouter({
    mode: 'history',
    base: base_url,
    routes
});



/**
 * Error: Avoided redundant navigation to current location
 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


// router.beforeEach((to, from, next) => {
//     console.log('beforeEach')
// })

// router.afterEach((to, from) => {
//     console.log('afterEach')
// })


export default router
